import React from 'react';
import Text from 'components/Text';

const AutoCompleteSellerModel: React.FC = (props: any) => {
  const { item } = props;
  return (
    <>
      <Text className="text-left color-blue-gray pt-1" size={13}>
        {item.name}
      </Text>
      <Text className="text-left pb-1" size={10}>
        {`${item.code} - ${item.name}`}
      </Text>
    </>
  );
};

export default AutoCompleteSellerModel;
